module.exports = __webpack_public_path__ + "static/website-4529f17b34f7c6dae27c6a3af5278ac8.png";